class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active') || this.openTimer) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.dispatchEvent(new CustomEvent('darchi:cart-opening', { bubbles: true }));
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    this.onOpenTransitionEnd = (event) => {
      if (event.target.matches('.drawer__inner') && event.propertyName === 'transform') this.focusDrawer();
    };
    this.addEventListener('transitionend', this.onOpenTransitionEnd);
    this.openTimer = window.setTimeout(() => {
      this.openTimer = null;
      this.classList.add('animate', 'active');
      // Reduced-motion settings may prevent transitionend from firing.
      this.focusTimer = window.setTimeout(() => this.focusDrawer(), 450);
    });
    document.body.classList.add('overflow-hidden');
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  focusDrawer() {
    if (!this.classList.contains('active')) return;
    window.clearTimeout(this.focusTimer);
    this.removeEventListener('transitionend', this.onOpenTransitionEnd);
    const container = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : this.querySelector('#CartDrawer');
    if (!container) return;
    const focusElement = container.querySelector('.drawer__close') || getFocusableElements(container)[0] || container;
    trapFocus(container, focusElement);
  }

  close(restoreFocus = true) {
    const wasOpen = this.classList.contains('active') || !!this.openTimer;
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.focusTimer);
    this.openTimer = null;
    this.removeEventListener('transitionend', this.onOpenTransitionEnd);
    this.classList.remove('active');
    if (!wasOpen) return;
    removeTrapFocus(restoreFocus !== false && this.activeElement?.isConnected ? this.activeElement : null);
    document.body.classList.remove('overflow-hidden');
  }

  disconnectedCallback() {
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.focusTimer);
    this.removeEventListener('transitionend', this.onOpenTransitionEnd);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
